import { config } from '@tonic/central-specialties-ui-config';
const sizeVariants = Object.keys(config.tokens.letterSpacings);
export const scaleSizeVariant = (
/**
 * Starting size variant
 */
size, 
/**
 * Scale factor, positive or negative
 * default: +1
 */
scale = 1) => {
    const index = sizeVariants.indexOf(size);
    // shift the index, ensuring it's within the bounds of the array
    const newIndex = Math.max(Math.min(index + scale, sizeVariants.length - 1), 0);
    return sizeVariants[newIndex];
};
